function isColliding(a, b, divHeight) {
    const animationSeconds = 40;
    const speed = divHeight * 2 / animationSeconds;
    const time = (Date.now() - b.startTime)/1000;
    b.y = divHeight - (speed*time);
    return !(
        a.x + a.width < b.x ||
        a.x > b.x + b.width ||
        a.y + a.height < b.y ||
        a.y > b.y + b.height
    );
}

function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomArr(arr) {
    const totalWeight = arr.reduce((sum, d) => sum + Math.floor(d.weight), 0);
    let chosen;

    if (totalWeight === 0) {
        chosen = arr[Math.floor(Math.random() * arr.length)];
    } else {
        let r = Math.random() * totalWeight;

        for (const d of arr) {
            const w = Math.floor(d.weight);
            if (r < w) {
                chosen = d;
                break;
            }
            r -= w;
        }
    }

    chosen.weight = Math.max(chosen.weight - 1, 0);
    for (const d of arr) {
        if (d.id !== chosen.id) {
            d.weight = Math.min(d.weight + 0.5, 3);
        }
    }

    return chosen;
}


export { isColliding, randomInt, randomArr }